import moment from "moment";

export function getFirstPickupSlot(now = moment()) {
  const base = now.clone().startOf("minute").seconds(0).milliseconds(0);
  const minute = base.minute();
  const hoursToAdd = minute <= 10 ? 1 : 2;
  return base.clone().startOf("hour").add(hoursToAdd, "hour");
}

export function getPickupSlotMoments(count = 10, now = moment()) {
  const first = getFirstPickupSlot(now);
  return Array.from({ length: count }, (_, i) => first.clone().add(i, "hour"));
}

export function formatPickupDisplayLabel(m) {
  return m.clone().locale("en").format("HH:mm D MMM YYYY");
}

export function formatPickupScheduleApi(m) {
  return m.clone().format("YYYY-MM-DD HH:mm:ss");
}
